import z from "zod";

import { tshirtSizeSchema } from "@/db/schema";

export const membershipItemSchema = z.object({
  profileId: z.number(),
  tshirtSize: tshirtSizeSchema.nullish(),
});

export type MembershipItem = z.infer<typeof membershipItemSchema>;

export const cartSchema = z.object({
  memberships: z.array(membershipItemSchema).default([]),
  teams: z
    .array(
      z.object({
        divisionId: z.number(),
        profileIds: z.array(z.number()),
      }),
    )
    .default([]),
});

export const checkoutSchema = z.object({
  billingInformation: z.object({
    firstName: z.string().nonempty("First name is required"),
    lastName: z.string().nonempty("Last name is required"),
    address: z
      .array(z.string())
      .min(1, "Address is required")
      .max(2)
      .refine((arr) => arr[0]?.trim().length > 0, {
        message: "Address is required",
        path: [0],
      }),
    city: z.string().nonempty("City is required"),
    state: z.string().nonempty("State is required"),
    postalCode: z.string().nonempty("Postal code is required"),
  }),
  paymentKey: z.string(),
  emailOptIn: z.boolean().optional(),
  cart: cartSchema,
});

// Structured error types for granular UI feedback
export type CartErrorType =
  | "existing_registration"
  | "cart_conflict"
  | "gender_mismatch"
  | "level_mismatch"
  | "missing_profile"
  | "missing_membership"
  | "team_incomplete"
  | "missing_tshirt_size"
  | "duplicate_membership"
  | "active_membership"
  | "division_at_capacity"
  | "division_not_found"
  | "requirement_not_met"
  | "registration_closed"
  | "registration_paused"
  | "registration_not_open";

export type CartError = {
  type: CartErrorType;
  message: string;
  profileId?: number;
  profileIds?: number[]; // For team-level errors, identifies which team
  divisionId?: number;
  tournamentDate?: string;
};
